import { AutogenModelDistanceMethod, AutogenRowDistanceMethod } from "./autogen/AutogenModelDistanceMethod";

export class ModelDistanceMethod extends AutogenModelDistanceMethod<RowDistanceMethod> {
	constructor() {
		super(RowDistanceMethod);
	}
}

export class RowDistanceMethod extends AutogenRowDistanceMethod {
}